import { setRangeMin } from './helpers';

export const setFloorMin = setRangeMin('floor');
